import React, { useEffect, useCallback, useState } from 'react';
// import { useTranslation } from "react-i18next";
import { Row, Col } from 'react-bootstrap';
import { motion } from "framer-motion";
import "./index.scss";

import SkeletonLoader from "../../../../../components/ui/SkeletonLoader";

import { formatNumber } from "../../../../../utils/util";

import { useScanInfoContext } from "../../../../ScanInfo/ScanInfoContext";

import { useSelector, useDispatch } from 'react-redux';
import { getBrandInsight, getInfraStructure, getDarkWebStats } from "../../../../../store/actions/dashboardAction";

const BrandInsights = () => {

    const brandInsightResponse = useSelector((state) => state?.dashboard?.brandInsight)
    const infrastructureResponse = useSelector((state) => state?.dashboard?.infrastructure)
    const darkWebStatsResponse = useSelector((state) => state.dashboard.darkWebStats)

    const dispatch = useDispatch();

    const {
        domainId,
        scanId,
        organizationId,
        triggerStatsFetch,
        setTriggerStatsFetch,
    } = useScanInfoContext();

    const [brandInsightLoading, setBrandInsightLoading] = useState(false);
    const [darkWebLoading, setDarkwebLoading] = useState(false);

    const fetchBrandInsight = useCallback(()=>{
        setBrandInsightLoading(true)
        setDarkwebLoading(true)
        const params = organizationId.toLowerCase() !== "all" && domainId.toLowerCase() === "all" ? `&organization_id=${organizationId}`: `&domain=${domainId}&scan_id=${scanId}`
        dispatch(getBrandInsight(params))
        dispatch(getInfraStructure(params))
        dispatch(getDarkWebStats(params))
    },[organizationId, domainId, scanId, dispatch])

    useEffect(() => {
        if (triggerStatsFetch) {
            fetchBrandInsight()
            setTriggerStatsFetch(false);
        }
    }, [triggerStatsFetch, setTriggerStatsFetch, fetchBrandInsight]);

    useEffect(()=>{
        if(brandInsightResponse !== null) {
            setBrandInsightLoading(false)
        }
    },[brandInsightResponse])

    useEffect(() => {
        if(infrastructureResponse !== null) {
        }
    },[infrastructureResponse])

    useEffect(()=>{
        if(darkWebStatsResponse !== null) {
           setDarkwebLoading(false)
        }
    },[darkWebStatsResponse])

    return (

        <div className="brand-main-content mt-4">
            {
                brandInsightLoading ?
                <SkeletonLoader type={"line"} count={4}/>
                :
                <Row>
                    <Col lg={4}>
                        <motion.div
                            initial={{ opacity: 0, y: 20 }}
                            animate={{ opacity: 1, y: 0 }}
                            transition={{ duration: 0.4 }}
                        >
                            <div className="bg-white-with-shadow p-4">
                                <div className="d-flex justify-content-between mb-3 dashboard-box-container">
                                    <p className="heading">Brand Insights</p>
                                    {/* <p className="view-all"><img src={move} alt="search" className="position-absolute search-icon" /></p> */}
                                </div>
                                <div className="brand-container rounded p-3">
                                    <div className="header-content d-flex justify-content-between">
                                        <p className="heading mr-3">Similar Domains</p>
                                    </div>
                                    <div className="d-flex gap-3">
                                        <div className="total-score-container rounded">
                                            <div className="users-totol-count d-flex">
                                                <p className="total-score-count">{formatNumber(brandInsightResponse?.stats?.similar_domain?.total)}</p>
                                                <div className="score-count mx-3">
                                                    <span className="new-record d-inline-block mx-1"></span>
                                                    <span className="existing-record d-inline-block"></span>
                                                    <p>Total </p>
                                                </div>
                                            </div>
                                            <div className="new-exist-count d-flex gap-3 mt-3">
                                                <p className="new-record"><span className="d-inline-block">{formatNumber(brandInsightResponse?.stats?.similar_domain?.new_record)}</span> New</p>
                                                <p className="existing-record"><span className="d-inline-block">{formatNumber(brandInsightResponse?.stats?.similar_domain?.existing_record)}</span> Existing</p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </motion.div>
                    </Col>
                    <Col lg={8}>
                        <motion.div
                            initial={{ opacity: 0, y: 20 }}
                            animate={{ opacity: 1, y: 0 }}
                            transition={{ duration: 0.4 }}
                        >
                            <div className="bg-white-with-shadow p-4">
                                <div className="d-flex justify-content-between mb-3 dashboard-box-container">
                                    <p className="heading">Infrastructure Risks</p>
                                    {/* <p className="view-all"><img src={move} alt="search" className="position-absolute search-icon" /></p> */}
                                </div>
                                <Row>
                                    <Col lg={6}>
                                        <div className="brand-container rounded p-3">
                                            <div className="header-content d-flex justify-content-between">
                                                <p className="heading">Risky Ports</p>
                                            </div>
                                            <div className="d-flex gap-3">
                                                <div className="total-score-container rounded">
                                                    <div className="users-totol-count d-flex">
                                                        <p className="total-score-count">{formatNumber(infrastructureResponse?.stats?.risk_port?.total)}</p>
                                                        <div className="score-count mx-3">
                                                            <span className="new-record d-inline-block mx-1"></span>
                                                            <span className="existing-record d-inline-block"></span>
                                                            <p>Total</p>
                                                        </div>
                                                    </div>
                                                    <div className="new-exist-count d-flex gap-3 mt-3">
                                                        <p className="new-record"><span className="d-inline-block">{formatNumber(infrastructureResponse?.stats?.risk_port?.new_record)}</span> New </p>
                                                        <p className="existing-record"><span className="d-inline-block">{formatNumber(infrastructureResponse?.stats?.risk_port?.existing_record)}</span> Existing </p>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </Col>
                                    <Col lg={6}>
                                        <div className="brand-container rounded p-3">
                                            <div className="header-content d-flex justify-content-between dashboard-box-container">
                                                <p className="heading">Blacklisted IPs</p>
                                            </div>
                                            <div className="d-flex gap-3">
                                                <div className="total-score-container rounded">
                                                    <div className="users-totol-count d-flex">
                                                        <p className="total-score-count">{formatNumber(infrastructureResponse?.stats?.blacklisted_ip_address?.total)}</p>
                                                        <div className="score-count mx-3">
                                                            <span className="new-record d-inline-block mx-1"></span>
                                                            <span className="existing-record d-inline-block"></span>
                                                            <p>Total</p>
                                                        </div>
                                                    </div>
                                                    <div className="new-exist-count d-flex gap-3 mt-3">
                                                        <p className="new-record"><span className="d-inline-block">{formatNumber(infrastructureResponse?.stats?.blacklisted_ip_address?.new_record)}</span> New</p>
                                                        <p className="existing-record"><span className="d-inline-block">{formatNumber(infrastructureResponse?.stats?.blacklisted_ip_address?.existing_record)}</span> Existing</p>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </Col>
                                </Row>
                            </div>
                        </motion.div>
                        
                    </Col>
                </Row>
            }

            <div className="bg-white-with-shadow p-4 mt-4">
                {
                    darkWebLoading ?
                    <SkeletonLoader type={"line"} count={4} />
                    :
                    <motion.div
                        initial={{ opacity: 0, y: 20 }}
                        animate={{ opacity: 1, y: 0 }}
                        transition={{ duration: 0.4 }}
                    >
                        <Row>
                            <div className="d-flex justify-content-between mb-3 dashboard-box-container">
                                <p className="heading">Dark Web Discovery</p>
                                {/* <p className="view-all"><img src={move} alt="search" className="position-absolute search-icon" /></p> */}
                            </div>
                            <Col lg={4}>
                                <div className="brand-container rounded p-3">
                                    <div className="header-content d-flex justify-content-between">
                                        <p className="heading mr-3">Infected by Infostealer</p>
                                    </div>
                                    <div className="d-flex gap-3">
                                        <div className="total-score-container rounded">
                                            <div className="users-totol-count d-flex">
                                                <p className="total-score-count">{formatNumber(darkWebStatsResponse?.stats?.botnet_leak?.total)}</p>
                                                <div className="score-count mx-3">
                                                    <span className="new-record d-inline-block mx-1"></span>
                                                    <span className="existing-record d-inline-block"></span>
                                                    <p>Total </p>
                                                </div>
                                            </div>
                                            <div className="new-exist-count d-flex gap-3 mt-3">
                                                <p className="new-record"><span className="d-inline-block">{formatNumber(darkWebStatsResponse?.stats?.botnet_leak?.new_record)}</span> New</p>
                                                <p className="existing-record"><span className="d-inline-block">{formatNumber(darkWebStatsResponse?.stats?.botnet_leak?.existing_record)}</span> Existing</p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </Col>
                            <Col lg={4}>
                                <div className="brand-container rounded p-3">
                                    <div className="header-content d-flex justify-content-between">
                                        <p className="heading">Leaked Credentials</p>
                                    </div>
                                    <div className="d-flex gap-3">
                                        <div className="total-score-container rounded">
                                            <div className="users-totol-count d-flex">
                                                <p className="total-score-count">{formatNumber(darkWebStatsResponse?.stats?.leaked_credential?.total)}</p>
                                                <div className="score-count mx-3">
                                                    <span className="new-record d-inline-block mx-1"></span>
                                                    <span className="existing-record d-inline-block"></span>
                                                    <p>Total</p>
                                                </div>
                                            </div>
                                            <div className="new-exist-count d-flex gap-3 mt-3">
                                                <p className="new-record"><span className="d-inline-block">{formatNumber(darkWebStatsResponse?.stats?.leaked_credential?.new_record)}</span> New </p>
                                                <p className="existing-record"><span className="d-inline-block">{formatNumber(darkWebStatsResponse?.stats?.leaked_credential?.existing_record)}</span> Existing </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </Col>
                            <Col lg={4}>
                                <div className="brand-container rounded p-3">
                                    <div className="header-content d-flex justify-content-between">
                                        <p className="heading">Ransomware Intel</p>
                                    </div>
                                    <div className="d-flex gap-3">
                                        <div className="total-score-container rounded">
                                            <div className="users-totol-count d-flex">
                                                <p className="total-score-count">{formatNumber(darkWebStatsResponse?.stats?.ransomware_group_leak?.total)}</p>
                                                <div className="score-count mx-3">
                                                    <span className="new-record d-inline-block mx-1"></span>
                                                    <span className="existing-record d-inline-block"></span>
                                                    <p>Total</p>
                                                </div>
                                            </div>
                                            <div className="new-exist-count d-flex gap-3 mt-3">
                                                <p className="new-record"><span className="d-inline-block">{formatNumber(darkWebStatsResponse?.stats?.ransomware_group_leak?.new_record)}</span> New</p>
                                                <p className="existing-record"><span className="d-inline-block">{formatNumber(darkWebStatsResponse?.stats?.ransomware_group_leak?.existing_record)}</span> Existing</p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </Col>
                        </Row>
                    </motion.div>
                }                
            </div>
        </div>

    )
}


export default BrandInsights;